import AsChildSlot from './AsChildSlot';
export * from './AsChildSlot';
export default AsChildSlot;
